import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Icon } from '@atlaskit/icon/base';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const RunsOnAtlassianIcon = props => {
  const RunsOnAtlassianGlyph = customGlyphProps => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.customSize || '16',
    height: props.customSize || '16',
    viewBox: "0 0 16 16",
    fill: "none"
  }, customGlyphProps), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.57471 0.781006L14.2041 4.94319L7.57471 9.10538L0.945292 4.94319L7.57471 0.781006Z",
      fill: "var(--ds-icon-brand, #0C66E4)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.1 6.7104L7.5 10.2263L1.9 6.7104L0.500001 7.58937L7.5 11.9842L14.5 7.58937L13.1 6.7104Z",
      fill: "var(--ds-icon-brand, #0C66E4)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.1 9.50715L7.5 13.023L1.9 9.50715L0.500001 10.3861L7.5 14.781L14.5 10.3861L13.1 9.50715Z",
      fill: "var(--ds-icon-brand, #0C66E4)"
    })]
  }));
  return /*#__PURE__*/_jsx(Icon, _objectSpread({
    glyph: RunsOnAtlassianGlyph
  }, props));
};